module.exports = __webpack_public_path__ + "25dc3359d9f6b4dabdeaac5f37fd8a58.png";